<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="600"
  >
    <v-card width="600" class="mx-auto">
      <v-toolbar>
        <v-toolbar-title class="title">
          <span>
            {{ $t("joinPromotion") }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog" :disabled="activatingPromotion"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-text class="pa-6">
        <div class="px-2">
          <p>
            {{ $t("currentlyYouGotThisPromotion") }}
          </p>
          <v-card outlined class="pa-2 my-4">
            <div style="font-size: 1.2em;">
              <strong>
                {{ promotion.promo_title }} - {{ promotion.promo_code }}
              </strong>
            </div>
          </v-card>
          <p>
            {{ $t("ifYouContinueAnd") }}
            {{
              isNewPromotionTypeDeposit ? $t("theDeposit") : $t("theAdmission")
            }}
            {{
              isNewPromotionTypeDeposit
                ? $t("isConfirmedThisWillBeYourNewPromotionDeposit")
                : $t("isConfirmedThisWillBeYourNewPromotionOther")
            }}
          </p>
          <v-card outlined class="pa-2 my-4">
            <div style="font-size: 1.2em;">
              <strong v-if="newPromotion.promo_title">
                {{ newPromotion.promo_title }} - {{ newPromotion.promo_code }}
              </strong>
              <strong v-else>
                {{ newPromotion.promo_code }}
              </strong>
            </div>
          </v-card>
          <p class="overline ">
            {{ $t("attention") }}
          </p>
          <p class="px-4">
            {{ $t("when") }}
            {{
              isNewPromotionTypeDeposit ? $t("theDeposit") : $t("theAdmission")
            }}
            {{
              isNewPromotionTypeDeposit
                ? $t("promotionIsConfirmedDeposit")
                : $t("promotionIsConfirmedOther")
            }}
            <br />
            {{ $t("promotionBetsAfterTransfer") }}
          </p>
        </div>
      </v-card-text>
      <v-card-actions class="pb-4 pr-4">
        <v-spacer></v-spacer>
        <v-btn
          class="px-4"
          @click="closeDialog"
          :disabled="activatingPromotion"
        >
          {{ $t("BtnCancel") }}
        </v-btn>
        <v-btn
          class="px-4"
          color="primary"
          @click="confirm"
          :loading="activatingPromotion"
          :disabled="activatingPromotion"
        >
          {{ $t("confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "promotion", "newPromotion"],

  data: () => ({
    activatingPromotion: false,
  }),

  computed: {
    isNewPromotionTypeDeposit() {
      return (
        this.newPromotion.type_promo == "deposito" ||
        this.newPromotion.type_promo == "1ºdeposito"
      );
    },
  },

  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },

    confirm() {
      this.$emit("submit");
      this.$emit("closeDialog");
    },
  },
};
</script>
